@if (person()?.birth_year && !birthDate()) {
  <span>{{ person()?.birth_year }}</span>
  <span class="text-muted">, {{ 'person.person_information.approximate_age' | translate: { age: getYears() } }}</span>
} @else if (birthDate()) {
  <span>{{ birthDate() | date }}</span>
  <span class="text-muted">, {{ 'person.person_information.approximate_age' | translate: { age: getYears() } }}</span>
}
